export { default as Tabs } from './Tabs';
export { default as TabBar } from './TabBar';
export { default as Tab } from './Tab';



/** WEBPACK FOOTER **
 ** ./src/Tabs/index.js
 **/